<div class="flex items-center cursor-pointer hover:text-blue-600 transition-colors" (click)="navigateToRoute()">
  <span class="mr-1">{{ text }}</span>
  <mat-icon class="text-sm">open_in_new</mat-icon>
</div>
